module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product13-a2685d2855f22599da517418a4294e94.jpg";